import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'

import { useToast } from '@/components/ui'
import { projectService } from '@/services/http/projectService'

export function useGetTask({
  id,
  projectId,
}: {
  id: string
  projectId: string
}) {
  const { toast } = useToast()

  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: ['project-task', projectId, id],
    queryFn: () => projectService.projectTasks.getTask({ projectId, id }),
  })

  useEffect(() => {
    if (isError) {
      toast({
        title: 'Erro ao buscar tarefa',
        description: 'Por favor, tente novamente mais tarde',
        variant: 'destructive',
      })
    }
  }, [isError, toast])

  if (data) {
    return {
      task: data,
      isLoadingGetTask: isLoading,
      isErrorGetTask: isError,
      refetchGetTask: refetch,
    }
  }

  return {
    task: null,
    isLoadingGetTask: isLoading,
    isErrorGetTask: isError,
    refetchGetTask: refetch,
  }
}
